<p-tabs scrollable="true" class="pa-router-tabs">
  <ng-content></ng-content>
</p-tabs>
